import React from 'react';
import { Skeleton } from 'antd';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../redux/store';
import { SectionContent, SectionTitle, SectionText, EmptyState, EmptyStateText } from './Styles';
import { EMPTY_STATE_MESSAGES } from './constants';

const StaffManagementSection: React.FC = () => {
  const { staffManagement, loading } = useSelector(
    (state: RootState) => state.managerReports
  );

  if (loading.staffManagement) {
    return (
      <SectionContent>
        <Skeleton active paragraph={{ rows: 4 }} />
      </SectionContent>
    );
  }

  if (!staffManagement) {
    return (
      <EmptyState>
        <EmptyStateText>{EMPTY_STATE_MESSAGES.STAFF_MANAGEMENT}</EmptyStateText>
      </EmptyState>
    );
  }

  return (
    <SectionContent>
      <SectionTitle>Staff Management Details</SectionTitle>
      <SectionText>
        Detailed report on staff management including total staff count, active members,
        recent hires, and performance metrics.
      </SectionText>
      {/* Add more detailed content here when API data is available */}
    </SectionContent>
  );
};

export default React.memo(StaffManagementSection);
